import Clip from 'show-page/components/clip';
import styles from './styles.less';
import { observer, propTypes } from 'mobx-react';


function ClipList(props) {
    const className = cx({
        [styles.textList]: props.textOnly,
        [styles.thumbList]: !props.textOnly
    });
    const clipClassName = cx(props.clipClassName, {
        [styles.textListClip]: props.textOnly,
        [styles.thumbListClip]: !props.textOnly
    })
    return (
        <div
            className={ className }
            style={ props.style }>
            { props.clips.map(clip => (
                <Clip
                    className={ clipClassName }
                    highlightColor={ props.highlightColor }
                    key={ clip.id }
                    linkClassName={ props.textOnly ? styles.textListLink : null }
                    onClick={ props.onVideoSelect.bind(null, clip) }
                    rolloverTextColor={ props.rolloverTextColor }
                    selected={ props.selectedVideoId === clip.id }
                    textOnly={ props.textOnly }
                    video={ clip }
                />
            )) }
            { props.children }
        </div>
    );
}

ClipList.propTypes = {
    clipClassName: React.PropTypes.string,
    clips: propTypes.arrayOrObservableArray.isRequired,
    highlightColor: React.PropTypes.string,
    onVideoSelect: React.PropTypes.func.isRequired,
    selectedVideoId: React.PropTypes.string,
    textOnly: React.PropTypes.bool
};


export default observer(ClipList);



/** WEBPACK FOOTER **
 ** ./src/show-page/components/clip-list/index.js
 **/